export enum FieldGroupType {
    Bio = 1,
    SportStats = 2,
}